import Note from 'assets/icons/md/md-note.svg'

Note.displayName = 'Note'
export default Note
